/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCompleteEmailResponse
 */
export interface ControlCompleteEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlCompleteEmailResponse
     */
    access_token: string;
}

/**
 * Check if a given object implements the ControlCompleteEmailResponse interface.
 */
export function instanceOfControlCompleteEmailResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "access_token" in value;

    return isInstance;
}

export function ControlCompleteEmailResponseFromJSON(json: any): ControlCompleteEmailResponse {
    return ControlCompleteEmailResponseFromJSONTyped(json, false);
}

export function ControlCompleteEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCompleteEmailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access_token': json['access_token'],
    };
}

export function ControlCompleteEmailResponseToJSON(value?: ControlCompleteEmailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'access_token': value.access_token,
    };
}

